<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row class="flex">
      <el-input
        v-model="searchCondition.name"
        clearable
        size="small"
        placeholder="应用"
        class="w-200px mr-10px"
      ></el-input>
      <el-input
        class="w-200px mr-10px"
        v-model="searchCondition.applyDepartment"
        clearable
        size="small"
        placeholder="部门"
      ></el-input>
      <el-button type="primary" @click="searchTableData()">{{ $t('search') }}</el-button>
      <el-button size="small" @click="importFile">{{ $t('import') }}</el-button>
      <el-button size="small" @click="exportFile" :loading="exportLoading">{{
        $t('export')
      }}</el-button>
    </el-row>
    <el-table
      :data="tableData"
      class="mt-20px"
      border
      height="calc(100% - 106px)"
      v-loading="tableLoading"
    >
      <el-table-column :label="$t('申请应用')" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('申请部门')" prop="applyDepartment" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        :label="$t('描述')"
        prop="description"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('创建时间')"
        width="200"
        prop="creationTime"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column :label="$t('操作')" width="150">
        <template slot-scope="scope">
          <el-button
            :disabled="!$hasAccess('update')"
            size="mini"
            @click="handleRow(scope.row, 'edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            @click="handleRow(scope.row, 'read')"
            :disabled="!$hasAccess('read')"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px float-right"
      background
      @size-change="searchTableData()"
      @current-change="findTableData()"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size.sync="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.pageTotal"
    ></el-pagination>
    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchTableData"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import FnMixins from '@/assets/js/fnMixins'
import { ApplyApplicationApi } from '@wiz-api/open-api-management'
import dayjs from 'dayjs'

const applyApplicationApi = new ApplyApplicationApi()
export default {
  name: 'apiApplicationList',
  mixins: [FnMixins],
  data() {
    return {
      searchCondition: {
        name: '', // 应用
        applyDepartment: '', // 部门
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      tableLoading: false,
      tableData: [],
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      exportLoading: false,
    }
  },
  methods: {
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await applyApplicationApi.downloadTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: 'API应用导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await applyApplicationApi.callImport({
        file: formData.get('file'),
      })
      if (!err) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: 'API应用导入明细.xlsx',
          data: res,
        })
        this.searchTableData()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 导出
    async exportFile() {
      this.exportLoading = true
      const [err, res] = await applyApplicationApi.callExport({
        body: {
          name: this.searchCondition.name,
          department: this.searchCondition.applyDepartment,
        },
      })
      this.exportLoading = false
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: 'API应用导出结果.xlsx',
          data: res,
        })
      }
    },
    handleRow(row, type) {
      if (type === 'edit' || type === 'read') {
        this.$router.push(`./api-apply?id=${row.id}&type=${type}&check=verify`)
      }
    },
    searchTableData() {
      this.page.pageNo = 1
      this.findTableData()
    },
    async findTableData() {
      const reqData = {
        skipCount: this.page.pageNo,
        maxResultCount: this.page.pageSize,
        sorting: '',
        name: this.searchCondition.name,
        applyDepartment: this.searchCondition.applyDepartment,
      }
      this.tableLoading = true
      const [err, res] = await applyApplicationApi.getList(reqData)
      this.tableLoading = false
      if (!err) {
        this.tableData = _.map(res.items, (item) => {
          item.creationTime = dayjs(new Date(item.creationTime)).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        this.page.pageTotal = res.totalCount
      }
    },
  },
  created() {
    this.searchTableData()
  },
}
</script>
